import React, {
    useEffect,
    useState,
    useRef,
    Fragment,
} from 'react';
import PaymentMethodSelector from '../../shared/PaymentMethodSelector';
import { useDispatch, useSelector } from 'react-redux';
import { Divider, Tabs, Tab, Button, CircularProgress, FormHelperText, OutlinedInput } from '@mui/material';
import { getData, postData } from '../../services/fetch-service';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup'
import PayseraPayment from '../PayseraPayment';
import dayjs from 'dayjs';
import ReCAPTCHA from 'react-google-recaptcha';
import { LoadingOverlay, Loader, Text, Skeleton } from '@mantine/core';
import { setEsimPackageSelected, setEsimRefillSelected, setPaymentResponse } from '../store/dataslice';
import Swal from 'sweetalert2';
import { FaEuroSign } from 'react-icons/fa';
import { IoMdCheckmarkCircle } from 'react-icons/io';
import InputMask from 'react-input-mask';

const customLoader = (
    <div className="payment-load">
        <Loader color="#006" />
        <span>Në procesim...</span>
    </div>
);

// const BootstrapDialog = styled(Dialog)(({ theme }) => ({
//     '& .MuiDialogContent-root': {
//         padding: theme.spacing(2),
//     },
//     '& .MuiDialogActions-root': {
//         padding: theme.spacing(1),
//     },
// }));

const PrishtinaParking_PaymentFields = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const reCaptchaRef = useRef(null);
    const SelectedPayment = useSelector((state) => state.Website.data.PaymentSelected);

    const [parkingPriceList, setParkingPriceList] = useState([]);
    const [selectedParkingPrice, setSelectedParkingPrice] = useState(null);

    const [pagesaLoading, setPagesaLoading] = useState(false);
    const [loanLoading, setLoanLoading] = useState(false);
    const [updateLoader, setUpdateLoader] = useState(false);
    const [Loan, setLoan] = useState(false);
    const [shumaValue, setShumaValue] = useState(null);
    const [acceptPay, setAccpetPay] = useState(false);
    const [finalPay, setFinalPay] = useState(true);

    const [DataNumriSerik, setNumriSerik] = useState(null);
    const [paymentMethodCode, setPaymentMethodCode] = useState("wallet");

    const handleBack = () => {
        navigate('/');
        formik.resetForm();
        dispatch(setEsimPackageSelected(null));
        dispatch(setEsimRefillSelected(null));
    }

    const handlePaymentMethodCode = (event) => {
        setPaymentMethodCode(event.target.value);
    };

    const clickPaymentMethodCode = (value) => {
        setPaymentMethodCode(value);
    };

    //  *** add vlera per institucionin dhe llojin e pageses *** END
    const vala_validationSchema = Yup.object().shape({
        Email: Yup.string().email('Email nuk është valid!').required('Email është obligativ!'),
        // emri: Yup.string().required('Emri është obligative!'),
        // mbiemri: Yup.string().required('Mbiemri është obligativ!'),
        numriSerik: Yup.string().required('Targa e makinës është obligative!'),
    });

    const today = new Date();
    const strDataPageses = dayjs(today).format('DD/MM/YYYY');

    const formik = useFormik({
        initialValues: {
            Email: '',
            provizioni: 0,
            strProvizioni: '0',
            llojiPagesesID: '',
            numriIdentifikues: '',
            institucioniId: '',
            numriSerik: '',
            strDataPageses: `${strDataPageses}`,
            llojiKlientit: 'Fizik',
            llojiPagesesID: 1064,
            emri: '//',
            mbiemri: '//',
            pershkrimi: `${selectedParkingPrice ? selectedParkingPrice.zoneName : ''}`,
            strVlera: '',
            strVleraTotale: '0',
            paymentMethod: 3,
            paguesiNumriTelefonit: '',
            sherbimiTipiID: 7,
            // shpenzimet: 0,
            unirefOK: false,
            PaymentMethodCode: paymentMethodCode
        },
        validationSchema: vala_validationSchema,
        onSubmit: (values) => {
            const newValues = {
                ...values,
                pershkrimi: `${selectedParkingPrice ? selectedParkingPrice.zoneName : ''}`,
            }
            reCaptchaRef.current.reset();
            postPagesaPerSherbime(newValues);
        },
    });

    const postPagesaPerSherbime = async (data) => {
        const token = await reCaptchaRef.current.executeAsync();
        try {
            setUpdateLoader(true);
            const newData = {
                ...data,
                shuma: shumaValue,
                provizioni: provizioni && provizioni.provizioni,
                viti: `${new Date().getFullYear()}`,
                strProvizioni: `${provizioni && provizioni.provizioni}`,
                llojiPagesesID: 1064,
                institucioniId: 186,
                numriSerik: data.numriSerik,
                numriUnikPageses: null,
                strDataPageses: `${strDataPageses}`,
                strVlera: `${provizioni && provizioni.strShuma}`,
                strVleraTotale: `${provizioni && provizioni.strtotal_pagesa}`,
                token: token,
                PayWithLoan: Loan ? true : false,
                PaymentMethodCode: paymentMethodCode,
            }
            if (provizioni) {
                const response = await postData('Pagesat/PagesaPerSherbime', newData);
                if (response && response.status === 200) {
                    // if (!Loan && paymentMethodCode !== 'visa') {
                    //     dispatch(setPaymentResponse(response.data.respond));
                    //     setPagesaLoading(false);
                    // } else {
                    //     setLoanLoading(false);
                    //     const paymentWindow = window.open('', '_self');
                    //     paymentWindow.location.href = `${response.data.link}`;
                    // }
                    setLoanLoading(false);
                    setPagesaLoading(false);
                    setUpdateLoader(false);
                    const paymentWindow = window.open('', '_self');
                    paymentWindow.location.href = `${response.data.link}`;
                }
            }
        } catch (error) {
            setPagesaLoading(false);
            setLoanLoading(false);
            setUpdateLoader(false);
            Swal.fire({
                icon: 'error',
                title: 'Gabim',
                text: `${error.response ? error.response.data.modelState.Error.errors[0].errorMessage : "Pagesa dështoi!"}`
            });
        }
    }

    const handlePayProcess = () => {
        if (paymentMethodCode === "PaySeraKredi") {
            handlePayWithLoan();
        } else {
            handlePay();
        }
    }

    const handlePay = async () => {
        formik.validateForm().then(async (errors) => {
            if (Object.keys(errors).length === 0) {
                setPagesaLoading(true);
                // await getProvizioni();
                formik.handleSubmit();
            } else {
                formik.setTouched(Object.keys(formik.values).reduce((acc, key) => {
                    acc[key] = true;
                    return acc;
                }, {}));
            }
        });
    };

    const handlePayWithLoan = () => {
        formik.validateForm().then((errors) => {
            if (Object.keys(errors).length === 0) {
                setLoanLoading(true);
                setLoan(true);
                formik.handleSubmit();
            } else {
                formik.setTouched(Object.keys(formik.values).reduce((acc, key) => {
                    acc[key] = true;
                    return acc;
                }, {}));
            }
        });
    }

    const getValaInternetList = async () => {
        try {
            const response = await getData('Home/GetPrishtinaParkingPrice');
            if (response && response.data) {
                setParkingPriceList(response.data)
            }
        } catch (error) {
            setParkingPriceList([]);

        }
    }

    useEffect(() => {
        getValaInternetList();
    }, []);

    // provisioni
    const [provizioni, setProvizioni] = useState(null);
    const [shumaKey, setShumaKey] = useState(0);

    const getProvizioni = async (data) => {
        try {
            setAccpetPay(true);
            const response = await getData(`Pagesat/GetProvision?LlojiPagesesID=1064&Amount=${shumaValue}`, data);
            if (response && response.data && response.data.success === true) {
                setProvizioni(response.data);
                setAccpetPay(false);
                setFinalPay(false);
            } else if (response && response.data && response.data.success === false) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Informim',
                    text: `${response.data.responseText}`
                });
                formik.setFieldValue('shuma', null);
                setShumaValue(null);
                setProvizioni(null);
                setShumaKey(prev => prev + 1);
            }
        } catch (error) {
            formik.setFieldValue('shuma', null);
            setShumaValue(null);
            setProvizioni(null);
            setShumaKey(prev => prev + 1);

        }
    }

    useEffect(() => {
        if (selectedParkingPrice !== null) {
            setShumaValue(selectedParkingPrice.price);
            setNumriSerik(selectedParkingPrice.price)
        }
    }, [selectedParkingPrice]);

    useEffect(() => {
        if (shumaValue !== null) {
            getProvizioni();
        }
    }, [shumaValue]);

    const handleParkingPriceBox = (data) => {
        setSelectedParkingPrice(data);
        setPaymentMethodCode("wallet");
    };

    return (
        <div className="paysera-home paysera-feilds">
            <div className="home-header">
                <h1 className='headline-font'>
                    {SelectedPayment.description}
                </h1>
                {/* <span className='home-description body-font'>Platforma jonë ju ofron një mënyrë të shpejtë, të sigurt dhe të thjeshtë për të kryer pagesat direkt nga telefoni ose kompjuteri juaj.</span> */}
            </div>
            <div className="paysera-form-body other-feilds">
                <div className="form-box">
                    <div className="form-body">
                        <div className="paysera-pr-parking-form">
                            <Fragment>  {
                                parkingPriceList.length === 0 ? (
                                    <div className="pr-parking-grid">
                                        {Array.from({ length: 3 }).map((_, index) => (
                                            <Skeleton key={index} height={120} width={165} className="skeleton-box" />
                                        ))}
                                    </div>
                                )
                                    : (
                                        <div className={`pr-parking-grid ${acceptPay ? 'loading-pr-parking-grid' : ''}`}>
                                            {parkingPriceList.map((item, index) => (
                                                <div
                                                    key={index}
                                                    onClick={() => {
                                                        if (!acceptPay) handleParkingPriceBox(item);
                                                    }}
                                                    className={`${selectedParkingPrice?.price === item.price ? 'selected-parking-card' : 'parking-card'} ${acceptPay ? 'loading-parking-card' : ''}`}
                                                >

                                                    <div className="internet-details">
                                                        <span className='parking-zone'>{item.zoneName}</span>
                                                    </div>

                                                    <div className="internet-desc">
                                                        <Text>Çmimi {item.price}€ / {item.description}</Text>
                                                        {/* <Text c="dimmed">Koha: </Text> */}
                                                    </div>

                                                    {
                                                        selectedParkingPrice?.price === item.price ? (
                                                            <span className='checked'>{!acceptPay ? <IoMdCheckmarkCircle /> : <CircularProgress size={14} color="inherit" />}</span>
                                                        ) :
                                                            ('')
                                                    }

                                                </div>
                                            ))}
                                        </div>
                                    )}
                            </Fragment>
                            <div className="paysera-form pr-parking-details-form">

                                {/* <div className="paysera-inputLabel">
                                    <label
                                        className={formik.touched.emri && formik.errors.emri ? 'label-top' : ''}
                                        htmlFor='Emri'
                                    >
                                        Emri
                                        <span className="required"> *</span>
                                    </label>
                                    <div className="input">
                                        <OutlinedInput
                                            size="small"
                                            id="outlined-adornment-input"
                                            placeholder='Emri'
                                            type='text'
                                            name='emri'
                                            aria-describedby="outlined-input-helper-text"
                                            inputProps={{
                                                'aria-label': 'input',
                                            }}
                                            value={formik.values.emri}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.emri && formik.errors.emri}
                                        />
                                        {
                                            formik.touched.emri && formik.errors.emri && (
                                                <FormHelperText>{formik.errors.emri}</FormHelperText>
                                            )
                                        }
                                    </div>
                                </div> */}
                                {/* <div className="paysera-inputLabel">
                                    <label
                                        htmlFor="mbiemri"
                                        className={formik.touched.mbiemri && formik.errors.mbiemri ? 'label-top' : ''}
                                    >
                                        Mbiemri
                                        <span className="required"> *</span>
                                    </label>
                                    <div className="input">
                                        <OutlinedInput
                                            size="small"
                                            id="outlined-adornment-input"
                                            placeholder="Mbiemri"
                                            type='text'
                                            aria-describedby="outlined-input-helper-text"
                                            inputProps={{
                                                'aria-label': 'input',
                                            }}
                                            name='mbiemri'
                                            value={formik.values.mbiemri}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.mbiemri && formik.errors.mbiemri}
                                        />
                                        {
                                            formik.touched.mbiemri && formik.errors.mbiemri && (
                                                <FormHelperText>{formik.errors.mbiemri}</FormHelperText>
                                            )
                                        }
                                    </div>
                                </div> */}

                                <div className="paysera-inputLabel">
                                    <label
                                        htmlFor="numriSerik"
                                        className={formik.touched.numriSerik && formik.errors.numriSerik ? 'label-top' : ''}
                                    >
                                        Targa e makinës
                                        <span className="required"> *</span>
                                    </label>
                                    <div className="input">
                                        <OutlinedInput
                                            size="small"
                                            id="outlined-adornment-input"
                                            placeholder="Targa e makinës"
                                            type='text'
                                            aria-describedby="outlined-input-helper-text"
                                            inputProps={{
                                                'aria-label': 'input',
                                            }}
                                            name='numriSerik'
                                            value={formik.values.numriSerik}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.numriSerik && formik.errors.numriSerik}
                                        />
                                        {
                                            formik.touched.numriSerik && formik.errors.numriSerik && (
                                                <FormHelperText>{formik.errors.numriSerik}</FormHelperText>
                                            )
                                        }
                                    </div>
                                </div>

                                <div className="paysera-inputLabel">
                                    <label className={formik.touched.Email && formik.errors.Email ? 'label-top' : ''} htmlFor="Numri Serik">Email <span className="required">*</span></label>
                                    <div className="input">
                                        <OutlinedInput
                                            size="small"
                                            id="outlined-adornment-input"
                                            placeholder="Shëno email-in tuaj"
                                            name='Email'
                                            type="email"
                                            aria-describedby="outlined-input-helper-text"
                                            inputProps={{
                                                'aria-label': 'input',
                                            }}
                                            value={formik.values.Email}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.Email && formik.errors.Email}
                                        />
                                        {
                                            formik.touched.Email && formik.errors.Email && (
                                                <FormHelperText>{formik.errors.Email}</FormHelperText>
                                            )
                                        }
                                    </div>
                                </div>

                                <div className="paysera-inputLabel">
                                    <label
                                        className={formik.touched.shuma && formik.errors.shuma ? 'label-top' : ''}
                                        htmlFor="Shuma e pagesës"
                                    >
                                        Shuma e pagesës <span className="required">*</span>
                                    </label>
                                    <div className="input">
                                        <OutlinedInput
                                            size="small"
                                            id="shuma-input-nr"
                                            type='number'
                                            disabled
                                            name='shuma'
                                            key={shumaKey}
                                            placeholder="Shuma për pagesë"
                                            className='number-input'
                                            startAdornment={acceptPay && <CircularProgress size={18} color="inherit" />}
                                            aria-describedby="outlined-input-helper-text"
                                            inputProps={{
                                                'aria-label': 'input',
                                                // inputMode: 'numeric'
                                            }}
                                            value={shumaValue}
                                            endAdornment={<FaEuroSign />}
                                            error={formik.touched.shuma && formik.errors.shuma}
                                        />
                                        {
                                            formik.touched.shuma && formik.errors.shuma && (
                                                <FormHelperText>{formik.errors.shuma}</FormHelperText>
                                            )
                                        }
                                    </div>
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Provizioni"> Provizioni</label>
                                    <div className="input">
                                        <OutlinedInput
                                            size="small"
                                            id="outlined-adornment-input"
                                            placeholder="Provizioni"
                                            key={shumaKey}
                                            readOnly
                                            aria-describedby="outlined-input-helper-text"
                                            startAdornment={acceptPay && <CircularProgress size={18} color="inherit" />}
                                            inputProps={{
                                                'aria-label': 'input',
                                            }}
                                            name='Provizioni'
                                            value={provizioni && provizioni.provizioni}
                                        />
                                    </div>
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Provizioni">Shuma Totale</label>
                                    <div className="input">
                                        <OutlinedInput
                                            size="small"
                                            id="outlined-adornment-input"
                                            placeholder="Provizioni"
                                            endAdornment={<FaEuroSign />}
                                            key={shumaKey}
                                            readOnly
                                            startAdornment={acceptPay && <CircularProgress size={18} color="inherit" />}
                                            aria-describedby="outlined-input-helper-text"
                                            inputProps={{
                                                'aria-label': 'input',
                                            }}
                                            name='strVleraTotale'
                                            value={provizioni && provizioni.strtotal_pagesa}
                                        />
                                    </div>
                                </div>
                                <PaymentMethodSelector
                                    paymentMethodCode={paymentMethodCode}
                                    onPaymentMethodChange={handlePaymentMethodCode}
                                    onPaymentMethodClick={clickPaymentMethodCode}
                                />
                                <div className="p-buttons">
                                    <div className="payForm-btn">
                                        <Button type="button" variant="outlined" onClick={handleBack}>
                                            Kthehu
                                        </Button>
                                        {/* <Button
                                                id="payNow"
                                                type="button"
                                                variant="contained"
                                                onClick={handlePayWithLoan}
                                                // disabled
                                                disabled={loanLoading}
                                                startIcon={loanLoading && <CircularProgress size={20} color="inherit" />}
                                            >
                                                {loanLoading ? 'Loading...' : 'Paguaj përmes kredisë'}
                                            </Button> */}
                                        <Button
                                            id="payNow"
                                            type="button"
                                            variant="contained"
                                            onClick={handlePayProcess}
                                            disabled={finalPay || (pagesaLoading || acceptPay)}
                                            startIcon={pagesaLoading && <CircularProgress size={20} color="inherit" />}
                                        >
                                            {pagesaLoading ? 'Duke paguar...' : 'Paguaj'}
                                        </Button>
                                    </div>
                                </div>
                            </div>

                            {/* <div className="p-buttons">
                                    <div className="payForm-btn">
                                        <Button type="button" variant="outlined" onClick={handleBack}>
                                            Kthehu
                                        </Button>
                                    </div>
                                </div> */}
                        </div>
                    </div>
                </div>
            </div>
            <ReCAPTCHA
                badge="bottomleft"
                sitekey={process.env.REACT_APP_SITE_KEY}
                size="invisible"
                ref={reCaptchaRef}
            />
            <PayseraPayment />
            <LoadingOverlay loader={customLoader} visible={updateLoader} />
        </div >
    )
}

export default PrishtinaParking_PaymentFields
